import styled from 'styled-components';
import { Txt } from './txt';

export { AnimatedNumber } from './animated';
export { Txt, type TxtProps } from './txt';

export const UnselectableTxt = styled(Txt)`
  user-select: none;
`;
